import * as React from 'react';

import c4bLogo from 'images/ent-website/c4c-logo.svg';

import _t from 'i18n!nls/ent-website';

function C4CLogo() {
  return <img src={c4bLogo} width={240} alt={_t('Coursera for Campus')} />;
}

export default C4CLogo;
